<template lang="pug">
  div(class="circle-slider-wrapper")
    div(v-if="label" class="slider-label") {{ label }}
    div(class="slider-has-tooltip")
      div(class="input-container")
        div(class="input-wrapper")
          CircleSliderVKB(:value="value" @input="onInputCircular" :min="min" :max="max" :validValues="validvalues" :readonly="readonly" :prefix="prefix" :suffix="suffix" :theme="theme" :side="side")
</template>

<script>
import { CircleSliderVKB } from '../../thirdparty/CircleSlider';

export default {
  name: 'nSliderVKB',
  components: {
    CircleSliderVKB
  },
  props: {
    min: Number,
    max: Number,
    label: { type: String, default: '' },
    prefix: { type: String, default: '' },
    suffix: { type: String, default: '' },
    readonly: Boolean,
    side: { type: Number, default: 150 },
    theme: String,
    tooltip: Boolean,
    value: Number,
    validvalues: Array
  },
  methods: {
    onInputCircular(value) {
      this.$emit('input', parseInt(value, 10));
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/common/n-slider-vkb.vue